import React from 'react'
import { isAuthenticated } from 'utils/utilities'

const RestrictedLayout = ({ children }) => {

  return isAuthenticated() ? children : <></>
}

export default RestrictedLayout
